// The images column occupies 44% of the page's width
export const imagesColumnSizeRatio = 0.44;
export const imageYMargin = 10;
export const headerHeight = 36.9;
export const floorplanWidthToHeightRatio = 0.62;
export const buildingRenderWidthToHeightRatio = 0.73;
export const northArrowSize = 20;
